<div class="ecl-u-pb-xl ecl-u-pb-lg-3xl">
  <ecl-container>
    <ecl-row>
      <ecl-column col="12">
        <main>
          <ecl-h level="2" id="something-went-wrong" v-html="$t('general.404.title')"></ecl-h>
          <p v-html="$t('general.404.description')"></p>
          <ul class="ecl-unordered-list" v-html="$t('general.404.bullet_list')"></ul>
          <ecl-button
            class="ecl-u-mt-l"
            :text="$t('general.404.cta')"
            :ariaLabel="$t('general.404.cta')"
            :type="EclButtonType.Secondary"
            @click.prevent="performBackToHome"
          ></ecl-button>
        </main>
      </ecl-column>
    </ecl-row>
  </ecl-container>
</div>
